import styles from './DocumentBodyNavigation.scss';
import {partial} from 'lodash';

export const DocumentBodyNavigation = props => {
    const {scrollArea, scrollToArea} = props;

    const viewerStyle = scrollArea === 'viewerArea'
        ? styles.navSectionSelected
        : styles.navSection;
    const documentAttributesStyle = scrollArea === 'documentAttributesArea'
        ? styles.navSectionSelected
        : styles.navSection;
    const signaturesStyle = scrollArea === 'signaturesArea'
        ? styles.navSectionSelected
        : styles.navSection;
    const historyStyle = scrollArea === 'historyArea'
        ? styles.navSectionSelected
        : styles.navSection;

    const duration = 300;

    return (
        <section className={styles.documentBodyNavigation} data-cy="DocumentBodyNavigation">
            <nav onClick={partial(scrollToArea, 'viewerArea', duration)}
                className={viewerStyle}>Viewer</nav>
            <nav onClick={partial(scrollToArea, 'documentAttributesArea', duration)}
                className={documentAttributesStyle}>Attributes</nav>
            <nav onClick={partial(scrollToArea, 'signaturesArea', duration)}
                className={signaturesStyle}>Signatures</nav>
            <nav onClick={partial(scrollToArea, 'historyArea', duration)}
                className={historyStyle}>History</nav>
        </section>
    );
};

export default DocumentBodyNavigation;